// UserInvite.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import Invite from '../partials/UserComponents/Invite'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'
import styles from '../../../css/home.module.css'

function UserInvite (props) {
  const navigate = useNavigate()

  const goTo = React.useCallback(x => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    const { id: customerID } = AppStore.getCustomer()
    goTo(`/${customerID}/settings/users`)
  }, [goTo])

  const {
    auth: {
      logout,
    },
    route: {
      path,
    },
    intl: {
      formatMessage,
    },
  } = props

  const INVITE_USERS = formatMessage({
    id: 'navigation.invite',
    defaultMessage: 'Invite Users',
    description: 'Invite Users label',
  })

  return (
    <div>
      <Helmet><title>{INVITE_USERS}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        page={path}
        name={INVITE_USERS}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div>
          <div className={styles.pageContainer}>
            <section>
              <Invite user={AppStore.getUser()} />
            </section>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

UserInvite.propTypes = {
  auth: PropTypes.object,
  route: PropTypes.object,
  intl: PropTypes.object,
}

export default withAppStore(injectIntl(UserInvite))
